const createInitiallyExpanded = ({ initiallyExpanded }) => {
  if (initiallyExpanded.length > 0) {
    return initiallyExpanded.reduce(
      (acc, id) => ({
        ...acc,
        [id]: true,
      }),
      {}
    );
  }
  return {};
};

export default createInitiallyExpanded;
